import { useState } from "react";
import styles from "./SettingsPage.module.scss";
import { AppEnableDisableButton } from "../components/AppEnableDisableButton";

export function SettingsPage() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <main className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.pageTitle}>Settings</h1>
        <AppEnableDisableButton />
      </div>
    </main>
  );
}
